import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

export const useStyles = makeStyles(() => createStyles({
  primaryTagGroupFields: {
    display: 'flex',
    gap: '20px',
  },
}));
